
import React, { useEffect, useState } from "react";
import { Variables, variables } from '../Variables.js';
import TeamStats from './Stats/TeamStats';
import { useNavigate } from "react-router-dom";

function AllTeams() {

    const [teams, setState] = useState([])
    const [teamInfo, setTeamInfo] = useState([])
    const navigate = useNavigate()

    const queryParameters = new URLSearchParams(window.location.search)
    const playerTeamId = queryParameters.get("playerTeamId")

    //Load All Values for All Players (GET)
    const fetchTeamData = () => {
        fetch(variables.API_URL + 'Player/getAllNBATeams/' + playerTeamId)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch team data');
                }
                return response.json()
            })
            .then(data => {
                setState(data)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching team data: ", error);
                navigate('/error');
            });
    }

    //Run GET on page load
    useEffect(() => {
        fetchTeamData();
       
    }, [])


    return (
        <div className="props">
            <center><p>Opposing Team</p></center>
            <div>
                <div className="work-request--information">
                    <input id="teamName" name="teamName" list="teams" type="text" spellCheck="false" />
                    <datalist id="teams">
                        {teams.map(data =>

                            <option data-value={data.teamId} data-value2={data.teamAbv} value={data.name}></option>
                        )}
                    </datalist>

                    <input type="hidden" name="teamId" id="teamId" />
                    <input type="hidden" name="teamAbrev" id="teamAbrev" />

                </div>
                <center>
                    <input className="cta" type="submit" id="submit" value="Submit" />
                    
                </center>
            </div>
           
        </div>
    )

};

export default AllTeams;
